function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Sans"
    },
    d: "M 5 5 L 5 6 L 5 26 L 5 27 L 6 27 L 26 27 L 27 27 L 27 26 L 27 6 L 27 5 L 26 5 L 6 5 L 5 5 z M 7 7 L 25 7 L 25 25 L 7 25 L 7 7 z M 21.28125 11.28125 L 14 18.5625 L 10.71875 15.28125 L 9.28125 16.71875 L 13.28125 20.71875 L 14 21.40625 L 14.71875 20.71875 L 22.71875 12.71875 L 21.28125 11.28125 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Sans"
  }));
};

export default __webpack_public_path__ + "static/media/checked-checkbox.e4136a68.svg";
export { SvgComponent as ReactComponent };